// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_container_title__86aSx{
    display: flex !important;
    justify-content: space-between !important;
}

.styles_title__FLDKb {
  align-items: center;
  color: #18316e !important;
  display: flex;
}

.styles_titulosConfirmacao__PDXqd {
  align-items: center !important;
  color: #18316e !important;
  display: flex !important;
  justify-content: space-between !important;
}

.styles_btnContainer__z94sl {
  display: flex !important;
  justify-content: center !important;
}

.styles_btnDownload__Patbk {
  background: #18316e !important;
  color: white !important;
  width: 25rem !important;
  display: flex !important;
  justify-content: space-between !important;
  flex-direction: row-reverse !important;
  border-radius: 20px !important;
  align-items: center !important;
  padding: 0.5rem 1rem !important;
}

.styles_btnDownload__Patbk span {
  margin-left: 0.7rem !important;
}

.styles_btnDownload__Patbk:hover {
  background: #18306ec2 !important;
}

.styles_btnDownloadAll__cMnOD{
  border-color: #18316e !important;
  color: #18316e !important;
}

/* .btnActionContainer {
  display: flex !important;
  justify-content: space-between !important;
} */

.styles_btnFechar__BQoUJ {
  color: #18316e !important;
  border: 1px solid #18316e !important;
}

.styles_btnTopContainer__ozSjr {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
}

.styles_dialogConfirm__QFsuI {
  color: #18316e;
  text-align: center;
}

.styles_dialogConfirm__QFsuI div {
  display: flex;
  justify-content: space-around;
  margin-top: 2rem;
}

.styles_nao__rXALG {
  border-color: #18316e !important;
  color: #18316e !important;
  width: 8rem;
}

.styles_sim__GYwdH {
  background: #18316e !important;
  width: 8rem !important;
}

.styles_titleRecusa__LAsUU {
  color: #18316e;
  display: flex;
  font-size: 1.5rem;
  justify-content: center;
  margin-bottom: 1rem;
}

.styles_botoesRecusa__IvXS- {
  display: flex;
  justify-content: space-between;
  margin-top: 2rem;
}

.styles_titleMotivacao__BNBeP {
  color: #0f2047 !important;
  font-family: "Inter" !important;
  font-weight: 400 !important;
  text-align: center !important;
  font-size: 1rem !important;
  text-align: left !important;
}

.styles_content__motiv__6BM5N {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.styles_btnSubContainer__Ho0qi {
  display: flex;
}

.styles_titleConfirmContrato__LupM9{
  align-items: center;
  display: flex;
  justify-content: flex-start;
  margin-bottom: 1rem;
}

.styles_notConfirmContrato__DiHPI{
  border-color: #18316e !important;
  color: #18316e !important;
  margin-right: 1rem;
}

.styles_yesConfirmContrato__eVlr-{
  background-color: #18316e !important;
}

@media (max-width: 425px) {
  .styles_btnActionContainer__s0Rp1 {
    flex-direction: column;
  }
  .styles_btnSubContainer__Ho0qi {
    flex-direction: column;
  }
}

@media (max-width: 767px) {
  .styles_divBtnReprovar__Sz-vi {
    margin: 0.3rem 0;
  }
  .styles_btnTopContainer__ozSjr {
    flex-direction: column;
  }
}

@media (min-width: 768px) {
  .styles_divBtnReprovar__Sz-vi {
    margin-right: 1rem !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Juridico/ModalVisualizar/styles.module.css"],"names":[],"mappings":"AAAA;IACI,wBAAwB;IACxB,yCAAyC;AAC7C;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,wBAAwB;EACxB,yCAAyC;AAC3C;;AAEA;EACE,wBAAwB;EACxB,kCAAkC;AACpC;;AAEA;EACE,8BAA8B;EAC9B,uBAAuB;EACvB,uBAAuB;EACvB,wBAAwB;EACxB,yCAAyC;EACzC,sCAAsC;EACtC,8BAA8B;EAC9B,8BAA8B;EAC9B,+BAA+B;AACjC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;;;GAGG;;AAEH;EACE,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,+BAA+B;EAC/B,2BAA2B;EAC3B,6BAA6B;EAC7B,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;EACA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,6BAA6B;EAC/B;AACF","sourcesContent":[".container_title{\n    display: flex !important;\n    justify-content: space-between !important;\n}\n\n.title {\n  align-items: center;\n  color: #18316e !important;\n  display: flex;\n}\n\n.titulosConfirmacao {\n  align-items: center !important;\n  color: #18316e !important;\n  display: flex !important;\n  justify-content: space-between !important;\n}\n\n.btnContainer {\n  display: flex !important;\n  justify-content: center !important;\n}\n\n.btnDownload {\n  background: #18316e !important;\n  color: white !important;\n  width: 25rem !important;\n  display: flex !important;\n  justify-content: space-between !important;\n  flex-direction: row-reverse !important;\n  border-radius: 20px !important;\n  align-items: center !important;\n  padding: 0.5rem 1rem !important;\n}\n\n.btnDownload span {\n  margin-left: 0.7rem !important;\n}\n\n.btnDownload:hover {\n  background: #18306ec2 !important;\n}\n\n.btnDownloadAll{\n  border-color: #18316e !important;\n  color: #18316e !important;\n}\n\n/* .btnActionContainer {\n  display: flex !important;\n  justify-content: space-between !important;\n} */\n\n.btnFechar {\n  color: #18316e !important;\n  border: 1px solid #18316e !important;\n}\n\n.btnTopContainer {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 1rem;\n}\n\n.dialogConfirm {\n  color: #18316e;\n  text-align: center;\n}\n\n.dialogConfirm div {\n  display: flex;\n  justify-content: space-around;\n  margin-top: 2rem;\n}\n\n.nao {\n  border-color: #18316e !important;\n  color: #18316e !important;\n  width: 8rem;\n}\n\n.sim {\n  background: #18316e !important;\n  width: 8rem !important;\n}\n\n.titleRecusa {\n  color: #18316e;\n  display: flex;\n  font-size: 1.5rem;\n  justify-content: center;\n  margin-bottom: 1rem;\n}\n\n.botoesRecusa {\n  display: flex;\n  justify-content: space-between;\n  margin-top: 2rem;\n}\n\n.titleMotivacao {\n  color: #0f2047 !important;\n  font-family: \"Inter\" !important;\n  font-weight: 400 !important;\n  text-align: center !important;\n  font-size: 1rem !important;\n  text-align: left !important;\n}\n\n.content__motiv {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.btnSubContainer {\n  display: flex;\n}\n\n.titleConfirmContrato{\n  align-items: center;\n  display: flex;\n  justify-content: flex-start;\n  margin-bottom: 1rem;\n}\n\n.notConfirmContrato{\n  border-color: #18316e !important;\n  color: #18316e !important;\n  margin-right: 1rem;\n}\n\n.yesConfirmContrato{\n  background-color: #18316e !important;\n}\n\n@media (max-width: 425px) {\n  .btnActionContainer {\n    flex-direction: column;\n  }\n  .btnSubContainer {\n    flex-direction: column;\n  }\n}\n\n@media (max-width: 767px) {\n  .divBtnReprovar {\n    margin: 0.3rem 0;\n  }\n  .btnTopContainer {\n    flex-direction: column;\n  }\n}\n\n@media (min-width: 768px) {\n  .divBtnReprovar {\n    margin-right: 1rem !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container_title": `styles_container_title__86aSx`,
	"title": `styles_title__FLDKb`,
	"titulosConfirmacao": `styles_titulosConfirmacao__PDXqd`,
	"btnContainer": `styles_btnContainer__z94sl`,
	"btnDownload": `styles_btnDownload__Patbk`,
	"btnDownloadAll": `styles_btnDownloadAll__cMnOD`,
	"btnFechar": `styles_btnFechar__BQoUJ`,
	"btnTopContainer": `styles_btnTopContainer__ozSjr`,
	"dialogConfirm": `styles_dialogConfirm__QFsuI`,
	"nao": `styles_nao__rXALG`,
	"sim": `styles_sim__GYwdH`,
	"titleRecusa": `styles_titleRecusa__LAsUU`,
	"botoesRecusa": `styles_botoesRecusa__IvXS-`,
	"titleMotivacao": `styles_titleMotivacao__BNBeP`,
	"content__motiv": `styles_content__motiv__6BM5N`,
	"btnSubContainer": `styles_btnSubContainer__Ho0qi`,
	"titleConfirmContrato": `styles_titleConfirmContrato__LupM9`,
	"notConfirmContrato": `styles_notConfirmContrato__DiHPI`,
	"yesConfirmContrato": `styles_yesConfirmContrato__eVlr-`,
	"btnActionContainer": `styles_btnActionContainer__s0Rp1`,
	"divBtnReprovar": `styles_divBtnReprovar__Sz-vi`
};
export default ___CSS_LOADER_EXPORT___;
